import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-10',
    text: 'heading-m',
    button: 'mt-6 w-[320px]'
  }
});
